import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PrivateRoute from "./components/auth/PrivateRoute";
import WelcomePreonboarding from "./features/pre_onboarding/components/WelcomePreonboarding";
import NotFound from "./pages/404";
import GeneralDetailTask from "./pages/DashboardTasks/Pages/GeneralDetailTask";
import Login from "./pages/Login";
import { ROUTES } from "./constants/routes";
import CollaboratorFactsheet from "./pages/CollaboratorFactsheet";

const AppPreOnboarding = () => {
    return (
        <BrowserRouter>
            <Routes>
                {/* EMPLOYEE FOLDER */}
                <Route
                    path={"/welcome-preonboarding"}
                    element={<WelcomePreonboarding />}
                />
                <Route
                    path="/tasks/:id_task/user/:id_user/detail"
                    element={<GeneralDetailTask />}
                />
                <Route path="/login" element={<Login />} />
                <Route
                    path={ROUTES.collaborator_factsheet}
                    element={<CollaboratorFactsheet />}
                />

                <Route
                    path="*"
                    element={
                        <NotFound
                            hide_drawer={true}
                            homeLink="/welcome-preonboarding"
                        />
                    }
                />
            </Routes>
        </BrowserRouter>
    );
};

export default AppPreOnboarding;
